import type { ShippingFormFields, TelephoneFieldValue } from "@jti/commerce-types";

import type { MAGENTO_PAYMENT_METHOD_COMMON, MAGENTO_PAYMENT_METHOD_PAY_ON_DELIVERY } from "@checkout-v2/shared";

export type FastFlowShippingStepCandidateReady = ShippingFormFields & {
  deliveryOption: string;
  paymentMethodCode: string;
  magentoPaymentMethodType: typeof MAGENTO_PAYMENT_METHOD_COMMON | typeof MAGENTO_PAYMENT_METHOD_PAY_ON_DELIVERY;
  telephoneFallback: TelephoneFieldValue;
};
